import { EFormMode } from '@src/emp-3.0/types/common';
import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMemo, useEffect } from 'react';

export const isViewMode = (mode?: 'view' | 'edit' | 'new' | EFormMode) => {
  return mode === EFormMode.VIEW;
};

export const useIsPatternMode = () => {
  const { workbenchMode, userInfo } = useInitialInfoStore();
  const isInternalUser = userInfo?.username?.endsWith('@conviva.com');
  const location = useLocation();
  const navigate = useNavigate();

  const isPatternViewRoute = useMemo(() => {
    return location.pathname.includes('/metric-builder/pattern/');
  }, [location.pathname]);

  const isPatternCreateRoute = useMemo(() => {
    return location.pathname.includes('/workflow/pattern/');
  }, [location.pathname]);

  const patternViewPermission = useMemo(() => {
    return isPatternViewRoute || workbenchMode;
  }, [workbenchMode, isPatternViewRoute]);

  const patternCreatePermission = useMemo(() => {
    return (userInfo?.enable_pattern_flow && isInternalUser) || workbenchMode;
  }, [isInternalUser, workbenchMode, userInfo?.enable_pattern_flow]);

  useEffect(() => {
    if (isPatternViewRoute && !patternViewPermission) {
      navigate('/metric-builder', { replace: true });
    }
    if (isPatternCreateRoute && !patternCreatePermission) {
      navigate('/metric-builder', { replace: true });
    }
  }, [
    isPatternViewRoute,
    isPatternCreateRoute,
    navigate,
    patternViewPermission,
    patternCreatePermission,
  ]);

  return {
    patternViewPermission,
    patternCreatePermission,
    isPatternMode:
      (isPatternViewRoute || isPatternCreateRoute) &&
      (patternViewPermission || patternCreatePermission),
  };
};
